<template>
  <div>
    <el-button
      :type="buttonType"
      :class="classType"
      :disabled="disabled || inactive"
      @click="startCountdown"
    >
      {{ displayText }}
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'CountDown',
  props: {
    total: {
      type: Number,
      default: 60,
    },
    text: {
      type: String,
      default: '获取验证码',
    },
    renewText: {
      type: String,
      default: '重新获取验证码',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    classType: {
      type: String,
      default: 'button',
    },
    buttonType: {
      type: String,
      default: 'primary'
    },
  },
  data() {
    return {
      num: 0,
      inactive: false,
    };
  },
  computed: {
    displayText() {
      return this.num === 0 ? this.text : `${this.renewText} ( ${this.num}s )`;
    },
  },
  methods: {
    startCountdown() {
      if (parseInt(this.total, 10) > 0) {
        this.num = parseInt(this.total, 10) + 1;
        this.inactive = true;
        this.runCountdown();
        this.$emit('getCaptcha');
      }
    },
    runCountdown() {
      if (this.num > 0) {
        this.num = this.num - 1;
        setTimeout(this.runCountdown, 1000);
      } else {
        this.inactive = false;
      }
    },
  },
};
</script>

<style scoped>
/*.button {*/
  /*height: 100%;*/
  /*width: 100%;*/
  /*background-color: #2053cd;*/
  /*color: #fff;*/
  /*font-size: 12px;*/
  /*outline: 0;*/
  /*border: 0;*/
  /*border-radius: 4px;*/
  /*transition: background .3s ease-in-out;*/
/*}*/
/*.link {*/
  /*background: none;*/
  /*border: none;*/
/*}*/
/*.button[disabled] {*/
  /*background-color: rgba(76, 87, 101, .65);*/
  /*cursor: not-allowed;*/
/*}*/
/*.link[disabled] {*/
  /*color: #babdc4;*/
  /*cursor: not-allowed;*/
/*}*/
</style>
